/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import {
    object, number, string, shape, arrayOf,
} from 'prop-types';
import Divider from '@material-ui/core/Divider';
import ImageModal from './ImageModal';
import  StatusTracking from '../../common/StatusTracking';
import AddressHelper from '../OrderDetails/Helper/AddressHelper';
import { dateMMMMDDYYYY } from '../../utils/dateString';

import { secureProtocol } from '../../utils/secureProtocol';
import { getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';
import { getLanguageName } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import pdpDictionary from '../../../../components/GraphqlComponents/GraphqlProductPage/translations/pdpTranslations.json';

class ROSSMobileOrderListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
        };
    }

    productDetails = (item) => {
        const { order: { recipientProfiles }, dataDictionary } = this.props;
        const {
            openModal,
        } = this.state;
        const language = getLanguageName();

        let productName = item?.productName;
        if (language === '/fr') {
            const partNumber = `${item?.productBrand}-P-${item?.productSku?.replace(/(\d*).*/, '$1')}_name`;
            productName = pdpDictionary?.[partNumber] || productName;
        }

        const productImageURL = item.prdImgCtg ? secureProtocol(item.prdImgCtg) : item.prdImgCtg;
        const address = recipientProfiles?.[0]?.addressDetail?.[0] || {};
        const { zipCode, ...newAddress } = address;
        newAddress.zipcode = zipCode;
        newAddress.businessName = recipientProfiles?.[0]?.businessName;
        return (
            <Grid className="productInnerDiv" item xs={12}>
                <div className="headerItemLabel">
                    {language === '/en' ? 'Product Information' : dataDictionary?.['Product Information'] || 'Product Information'}
                </div>
                <div className="productContainer">
                    <div className="productTitle">
                        {language === '/en' ? 'Product Name' : dataDictionary?.['Product Name'] || 'Product Name'}
                        <button type="button" className="productLink" onClick={() => { this.setState({ openModal: true }); }}>{productName}</button>
                        <ImageModal isOpen={openModal} onClose={() => { this.setState({ openModal: false }); }} productImageURL={productImageURL} productSku={item.productSku} />
                    </div>
                    <div className="productTitle">
                        {language === '/en' ? 'Delivery Address' : dataDictionary?.['Delivery Address'] || 'Delivery Address'}
                        <AddressHelper address={newAddress} />
                    </div>
                    <div className="productTitle">
                        {language === '/en' ? 'Delivery Date' : dataDictionary?.['Delivery Date'] || 'Delivery Date'}
                        <div className="productInfo">{item.deliveryDate && dateMMMMDDYYYY(item.deliveryDate, dataDictionary)}</div>
                    </div>
                </div>
            </Grid>
        );
    };

    render() {
        const {
            order, index, brand,
        } = this.props;

        const {
            deliveryStatus, items,
        } = order;

        return (
            <React.Fragment key={index}>
                <Grid container className="orderItemGrid">
                    <Grid container>
                        <Grid className="orderStatusInfo" item xs={12}>
                            {index === 0 && (
                                <Grid container>
                                    <Grid item xs={12}>
                                        <StatusTracking
                                            status={deliveryStatus}
                                            brand={brand}
                                            trackingMobile
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                        {
                            items?.map((item) => this.productDetails(item))
                        }
                    </Grid>
                </Grid>
                <Divider />
            </React.Fragment>
        );
    }
}
ROSSMobileOrderListItem.propTypes = {
    order: shape({
        items: arrayOf(
            shape({
                productSku: string,
                deliveryDate: string,
                prdImgCtg: string,
                price: string,
                productName: string,
            }),
        ),
        recipientProfiles: arrayOf(
            shape({
                addressDetail: arrayOf(
                    shape({
                        addressLine1: string,
                        addressLine2: string,
                        addressLine3: string,
                        cityName: string,
                        countryCode: string,
                        state: string,
                        zipCode: string,
                    }),
                ),
            }),
        ),
    }).isRequired,
    index: number.isRequired,
    brand: object.isRequired,
    dataDictionary: object.isRequired,
};

const mapStateToProps = (state) => ({
    dataDictionary: getDataDictionary(state),
});

export default connect(
    mapStateToProps,
    null,
)(withRouter(ROSSMobileOrderListItem));
